// eslint-disable-next-line
import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import queryString from 'query-string'
import { history } from '../../_redux/_store/history'
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import {
  Tooltip,
  Button,
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  Snackbar,
  Divider,
  Box,
} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert'
import MuiBadge from "@material-ui/core/Badge";
import MuiAccordion from "@material-ui/core/Accordion";
import Card from "@material-ui/core/Card";
import MuiCardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import SignalsDialog from "./SignalsDialog";
import { fetchScopedFindingRule, updateScopedFindingRule } from "../../_redux/_actions/scopedFindingRuleActions";
import ErrorHandler from "../updateHandlers/ErrorHandler";
import SkeletonPaper from "../skeleton/SkeletonPaper";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { clearAnomalyRule } from "../../_redux/_actions/anomalyRuleActions";

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const Accordion = withStyles(() => ({
  root: {},
}))(MuiAccordion);

const AccordionDetails = withStyles(() => ({
  root: {
    padding: "42px 16px 16px",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}))(MuiAccordionDetails);

const AccordionSummary = withStyles(() => ({
  root: {
    backgroundColor: "#666666",
    color: "white",
  },
}))(MuiAccordionSummary);

const Badge = withStyles(() => ({
  badge: {
    backgroundColor: "#666666",
    color: "white",
  },
  anchorOriginTopRightRectangle: {
    top: "4px",
    right: "6px",
  },
}))(MuiBadge);

const CardHeader = withStyles(() => ({
  action: {
    marginTop: " -27px",
    marginRight: "-20px",
  },
}))(MuiCardHeader);

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: "5px",
  },
  editButton: {
    width: "20px",
    marginLeft: "0px",
  },
  eqPaper: {
    overflowY: "auto",
    maxHeight: 330,
    marginTop: 20,
    padding: 12,
  },
  configPaper: {
    margin: "40px 0px",
    backgroundColor: "#F6F6F6",
    padding: "30px",
  },
  operatorPaper: {
    paddingTop: "8px",
  },
  operatorList: {
    margin: "0px 5px",
  },
  bracket: {
    height: "100px",
  },
  equation: {
    height: "100%",
  },
  operatorButton: {
    margin: "10px",
    height: "35px",
    minWidth: "unset",
    background: "#fff",
  },
  card: {
    margin: "10px",
    width: "273px",
    boxShadow: "0px 1px 3px #00000066 !important",
  },
  operatorCard: {
    margin: "10px",
    boxShadow: "0px 1px 3px #00000066 !important",
    "& .MuiCardContent-root:last-child": {
      padding: "16px !important",
    },
  },
  cardHeader: {
    paddingBottom: "0px",
  },
  badge: {
    color: "white",
    backgroundColor: "#666666",
  },
}));

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  margin: `0 ${grid}px 0 0`,
  background: isDragging ? "lightgreen" : "transparent",
  alignSelf: "center",
  ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "#E5E5E5",
  display: "flex",
  padding: grid,
  overflow: "auto",
});

const operators = [
  ["[", "]"],
  ["AND", "OR", "NOT"],
  [
    <Tooltip title='undo'>
      <UndoIcon op='undo' />
    </Tooltip>,
    <Tooltip title='redo'>
      <RedoIcon op='redo' />
    </Tooltip>,
  ],
  ["REARRANGE"],
  ["ADD ANOMALY"],
];
const operatorObject = { "[": "(", "]": ")", AND: "AND", OR: "OR", NOT: "NOT" };

export const AnomalyConfiguration = React.memo((props) => {
  const { findingRuleId, scope, noteText } = props;
  const classes = useStyles();
  const [edited, setEdited] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [currentOperator, setCurrentOperator] = useState("");
  const [equationStack, setEquationStack] = useState([]);
  const [undoneStack, setUndoneStack] = useState([]);
  const dispatch = useDispatch();
  const [discard, setDiscard] = useState(false);
  const [keys, setKeys] = useState([]);
  const [eqCreated, setEqCreated] = useState(false);
  const error = useSelector((state) => state.scopedFindingRule.error);
  const anomalyRule = useSelector(
    (state) => state.detailsPersist.allAnomalyRules
  );
  const [isValidOperation, setIsValidOperation] = useState(true);
  var badgeCount = 0;
  const [rightBracketArray, setRightBracketArray] = useState([]);
  const [enableRearrange, setEnableRearrange] = useState(false);
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues

  const specificAnomalyRule = useSelector(
    (state) => state.selectScopedAnomalyRule.specificAnomalyRule
  );

  const clearStates = () => {
    setCurrentOperator("");
    setKeys([]);
    setRightBracketArray([]);
  };

  const getRule = (eq) => {
    return anomalyRule.find((rule) => rule.id === eq);
  };

  const createEquationList = () => {
    const operationEq = props.operationProp
      .toUpperCase()
      .replace(/"/g, "")
      .replace(/'/g, "")
      .replace(/\(/g, " ( ")
      .replace(/\)/g, " ) ")
      .split(" ")
      .filter((op) => op);
    var thisEqList = [];
    var curEq = [];
    operationEq.map((eq) => {
      curEq = [...curEq, eq];

      switch (eq) {
        case "AND":
        case "OR":
        case "NOT":
          thisEqList = [...thisEqList, { operator: eq }];
          break;
        case "(":
          thisEqList = [...thisEqList, { operator: "[" }];
          break;
        case ")":
          thisEqList = [...thisEqList, { operator: "]" }];
          break;
        default:
          var ruleObj = getRule(eq);
          thisEqList = [...thisEqList, { rule: ruleObj ? ruleObj : specificAnomalyRule[0] }];
          break;
      }
    });
    setEquationStack([
      ...equationStack,
      { preview: curEq.join(" ").toUpperCase(), operation: [...thisEqList] },
    ]);
  };

  useEffect(() => {
    return () => {
      dispatch(clearAnomalyRule());
    };
  }, []);

  useEffect(() => {
    if (props.operationProp && props.operationProp !== "None" && anomalyRule) {
      createEquationList();
    } else if (anomalyRule) {
      handleClearAll();
    }
  }, [props.operationProp, anomalyRule]);

  useEffect(() => {
    if (equationStack.length > 0) {
      var operation = [...equationStack[equationStack.length - 1].operation];
      var preview = equationStack[equationStack.length - 1].preview.split(" ");
      if (operation.length > 0) {
        const leftBracketCount = preview.filter((op) => op === "(").length;
        const rightBracketCount = preview.filter((op) => op === ")").length;
        if (rightBracketCount < leftBracketCount) {
          setRightBracketArray(
            new Array(leftBracketCount - rightBracketCount).fill("]")
          );
        } else {
          setRightBracketArray([]);
        }
      } else {
        setRightBracketArray([]);
        setCurrentOperator("");
      }
    } else {
      setRightBracketArray([]);
    }
  }, [equationStack, undoneStack]);


  const handleSpecificAnomalyRuleUpdate = useCallback(() => {
    if (specificAnomalyRule) {
      handleCloseDialog();
      updateEquationStack(specificAnomalyRule[0]);
    }
  }, [specificAnomalyRule]);

  // The effect will only be redefined when specificAnomalyRule changes
  useEffect(handleSpecificAnomalyRuleUpdate, [handleSpecificAnomalyRuleUpdate]);

  const validateOperation = (item, type, tempOperation, tempPreview) => {
    if (tempOperation && tempPreview) {
      var currentOperation = tempOperation;
      var preview = tempPreview;
    } else {
      var currentOperation =
        equationStack.length > 0 &&
        equationStack[equationStack.length - 1].operation;
      var preview =
        equationStack.length > 0 &&
        equationStack[equationStack.length - 1].preview;
    }
    if (currentOperation && currentOperation.length > 0) {
      var lastEntity = Object.entries(
        currentOperation[currentOperation.length - 1]
      )[0]; // last operation added to equation
      if (type === "operator") {
        //if incoming item is '['
        if (item === "[") {
          if (lastEntity[0] === "rule") {
            return false;
          }
          switch (lastEntity[1]) {
            case "]":
              return false;
              break;
            default:
              break;
          }
        }

        //if incoming item is ']'
        else if (item === "]") {
          if (!(preview.includes("(") || preview.includes("["))) {
            return false;
          }
          var currentPreview = tempPreview;
          if (tempPreview) {
            tempPreview.push("]");
          } else {
            var currentPreview = equationStack[equationStack.length - 1].preview
              .concat(" )")
              .split(" ");
          }
          var leftBracketCount = currentPreview.filter(
            (op) => op === "("
          ).length;
          var rightBracketCount = currentPreview.filter(
            (op) => op === ")"
          ).length;
          if (rightBracketCount > leftBracketCount) {
            return false;
          }
          switch (lastEntity[1]) {
            case "[":
              return false;
            case "AND":
              return false;
            case "OR":
              return false;
            case "NOT":
              return false;
            default:
              break;
          }
        }

        //if incoming item is 'AND'
        else if (item === "AND") {
          switch (lastEntity[1]) {
            case "[":
              return false;
            case "AND":
              return false;
            case "OR":
              return false;
            case "NOT":
              return false;
            default:
              break;
          }
        }

        //if incoming item is 'OR'
        else if (item === "OR") {
          switch (lastEntity[1]) {
            case "[":
              return false;
            case "AND":
              return false;
            case "OR":
              return false;
            case "NOT":
              return false;
            default:
              break;
          }
        }

        //if incoming item is 'NOT'
        else if (item === "NOT") {
          if (lastEntity[0] === "rule") {
            return false;
          }
          if (lastEntity[1] === "]") {
            return false;
          }
        }
      }
      // if  incoming item is a rule
      else {
        if (lastEntity[0] === "rule") {
          return false;
        }
        if (lastEntity[1] === "]") {
          return false;
        }
      }
    }
    // if incoming item is the first operation
    else {
      if (item === "AND" || item === "OR" || item === "]") {
        return false;
      }
    }
    return true;
  };

  const updateEquationStack = (item, type) => {
    const isValid = validateOperation(item, type);
    if (isValid) {
      if (type === "operator") {
        var previewItem = operatorObject[item];
        var operationItem = { operator: item };
      } else {
        var previewItem = item.id;
        var operationItem = { rule: item };
      }
      if (equationStack.length > 0) {
        var currentPreview =
          equationStack[equationStack.length - 1].preview + " " + previewItem;
        var currentOperation = [
          ...equationStack[equationStack.length - 1].operation,
          operationItem,
        ];
      } else {
        var currentPreview = previewItem;
        var currentOperation = [operationItem];
      }

      setCurrentOperator(currentOperation[currentOperation.length - 1]);
      setEquationStack([
        ...equationStack,
        {
          preview: currentPreview.toString(),
          operation: currentOperation,
        },
      ]);
      setIsValidOperation(true);
    } else {
      setIsValidOperation(false);
    }
  };

  const removeSelected = (currentPreview, currentOperation) => {
    keys.sort((a, b) => a - b);
    for (var i = keys.length - 1; i >= 0; i--) {
      currentPreview.splice(keys[i], 1);
      currentOperation.splice(keys[i], 1);
    }
    var isValid = true;
    // to validate equation
    var tempOperation = [];
    var tempPreview = [];
    currentOperation.forEach((operation) => {
      if (isValid) {
        var temp = Object.entries(operation)[0];
        isValid = validateOperation(
          temp[1],
          temp[0],
          tempOperation,
          tempPreview
        );

        tempOperation.push(operation);
        tempPreview.push(temp[1]);
      }
    });
    if (isValid) {
      currentPreview.length > 0 && currentOperation.length > 0
        ? equationStack.push({
            preview: currentPreview.join(" ").toUpperCase(),
            operation: currentOperation,
          })
        : setEquationStack([...equationStack, { preview: "", operation: [] }]);

      if (currentPreview.length > 0 && currentOperation.length > 0) {
        setEquationStack([...equationStack]);
        setCurrentOperator(currentOperation[currentOperation.length - 1]);
      }

      setKeys([]);
    } else {
      setIsValidOperation(false);
      return;
    }
  };

  const OperationsComponent = () => {
    const handleOperations = (operator) => {
      if (operator.props) {
        if (operator.props.title === "undo" && equationStack.length > 0) {
          if (
            props.operationProp.toUpperCase() !=
            equationStack[equationStack.length - 1].preview
          ) {
            {
              undoneStack.push(equationStack.pop());
              if (equationStack.length > 0) {
                var currentOp = [
                  ...equationStack[equationStack.length - 1].operation,
                ];
                setCurrentOperator(currentOp[currentOp.length - 1]);
              }

              setUndoneStack([...undoneStack]);
              setEquationStack([...equationStack]);
            }
          }
        } else if (operator.props.title === "redo" && undoneStack.length > 0) {
          equationStack.push(undoneStack.pop());
          var currentOp = [
            ...equationStack[equationStack.length - 1].operation,
          ];
          setCurrentOperator(currentOp[currentOp.length - 1]);
          setEquationStack([...equationStack]);
        }
      } else {
        setUndoneStack([]);
        if (
          operators[0].includes(operator) ||
          operators[1].includes(operator)
        ) {
          updateEquationStack(operator, "operator");
        } else if (operator === "ADD ANOMALY") {
          handleDialogOpen("paper");
        } else if (
          operator === "REMOVE SELECTED" &&
          equationStack.length > 0 &&
          keys.length > 0
        ) {
          var currentPreview =
            equationStack[equationStack.length - 1].preview.split(" ");
          var currentOperation = [
            ...equationStack[equationStack.length - 1].operation,
          ];
          removeSelected(currentPreview, currentOperation);
        } else if (operator === "REARRANGE") {
          setEnableRearrange(true);
          const lastOp=equationStack[equationStack.length-1].operation
          setCurrentOperator(lastOp[lastOp.length-1]);
        }
      }
    };

    return (
      <Paper className={classes.operatorPaper}>
        <Grid container>
          <Grid item md={9} container justifyContent='space-around'>
            <Grid item container>
              {operators.map((operatorList, index) => {
                return (
                  <Grid
                    item
                    key={`opList${index}`}
                    className={classes.operatorList}
                  >
                    {operatorList.map((operator, i) => {
                      return operator === "REARRANGE" && enableRearrange ? (
                        <Button
                          key={`op${i}`}
                          className={classes.operatorButton}
                          style={{ background: "#E5E5E5" }}
                          variant='outlined'
                          onClick={() => setEnableRearrange(false)}
                        >
                          {operator}
                        </Button>
                      ) : (
                        <Button
                          key={`op${i}`}
                          className={classes.operatorButton}
                          variant='outlined'
                          onClick={() => handleOperations(operator)}
                        >
                          {operator}
                        </Button>
                      );
                    })}
                  </Grid>
                );
              })}
            </Grid>
          </Grid>

          <Grid item md={3}>
            <Button
              onClick={() => handleOperations("REMOVE SELECTED")}
              className={classes.operatorButton}
              variant='outlined'
              style={{ marginLeft: 0 }}
            >
              REMOVE SELECTED
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  const updateKey = (key) => {
    if (keys.includes(key)) {
      keys.splice(keys.indexOf(key), 1);
      setKeys([...keys]);
    } else {
      setKeys([...keys, key]);
    }
  };

  const ConfigCard = ({ index, equation }) => {
    return (
      <Card
        className={`${keys.includes(index) && edited ? "selected" : ""} ${
          classes.card
        }`}
        onClick={() => {
          updateKey(index);
        }}
      >
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <>
              <Typography variant='subtitle2'>
                {equation ? equation.id : null}
              </Typography>
              <Divider orientation='vertical' flexItem />
            </>
          }
          subheader={
            equation && equation.anomalyType ? equation.anomalyType.id : null
          }
        />
        <CardContent>
          <Box component='div' overflow='auto'>
            <Typography variant='body2' color='textSecondary' component='p'>
              {equation && equation.signals
                ? equation.signals.map((eq) => {
                    return (
                      <li key={eq.id} style={{ listStyleType: "none" }}>
                        {eq.name}
                      </li>
                    );
                  })
                : null}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const ConfigOperator = ({ index, operator }) => {
    if (operator === "[") {
      badgeCount = badgeCount + 1;

      return (
        <Card
          className={`${keys.includes(index) && edited ? "selected" : ""} ${
            classes.operatorCard
          }`}
          variant='outlined'
          onClick={() => {
            updateKey(index);
          }}
        >
          <CardContent>{operator}</CardContent>
        </Card>
      );
    }
    if (operator === "]") {
      badgeCount = badgeCount - 1;
      return (
        <Card
          className={`${keys.includes(index) && edited ? "selected" : ""} ${
            classes.operatorCard
          }`}
          variant='outlined'
          onClick={() => {
            updateKey(index);
          }}
        >
          <CardContent>{operator}</CardContent>
        </Card>
      );
    } else
      return (
        <Card
          className={`${keys.includes(index) && edited ? "selected" : ""} ${
            classes.operatorCard
          }`}
          variant='outlined'
          onClick={() => {
            updateKey(index);
          }}
        >
          <CardContent>{operator}</CardContent>
        </Card>
      );
  };

  const ConfigurationComponent = () => {
    return (
      <Grid
        container
        justifyContent='space-between'
        className={classes.equation}
        spacing={3}
      >
        <Grid item container direction='row' alignItems='center'>
          {equationStack.length > 0 &&
            equationStack[equationStack.length - 1].operation.map(
              (equation, index) => {
                return Object.keys(equation)[0] === "rule" ? (
                  <ConfigCard
                    key={index}
                    index={index}
                    equation={equation["rule"]}
                  />
                ) : (
                  <ConfigOperator
                    key={index}
                    index={index}
                    operator={equation["operator"]}
                  />
                );
              }
            )}
        </Grid>
      </Grid>
    );
  };

  const DiscardDialog = () => {
    return (
      <Dialog open={discard} onClose={handleDiscard}>
        <DialogTitle id='alert-dialog-title'>
          {"Do you want to discard changes?"}
        </DialogTitle>

        <DialogActions>
          <Button
            onClick={() => {
              handleDiscard("ok");
            }}
            className='btn-primary'
          >
            Ok
          </Button>
          <Button
            onClick={() => handleDiscard("cancel")}
            className='btn-primary'
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleDialogOpen = (scrollType) => {
    const isValid = validateOperation("", "rule");
    if (isValid) {
      setOpen(true);
      setScroll(scrollType);
    } else {
      setIsValidOperation(false);
    }
  };

  const handleCloseDialog = (selectedEntities) => {
    setOpen(false);
  };

  const updateRight = (n) => {
    if (validateOperation("]", "operator")) {
      var brackets = [];
      var currentPreview =
        equationStack[equationStack.length - 1].preview.split(" ");
      var currentOperation = [
        ...equationStack[equationStack.length - 1].operation,
      ];
      Array(n)
        .fill()
        .map((item, index) => {
          brackets = [...brackets, { operator: "]" }];
          currentPreview = [...currentPreview, ")"];
        });
      setEquationStack([
        ...equationStack,
        {
          preview: currentPreview.join(" ").toUpperCase(),
          operation: [...currentOperation, ...brackets],
        },
      ]);
    } else {
      setIsValidOperation(false);
    }
  };

  const handleDone = () => {
    const body = {
      finding_rule_id: findingRuleId,
      scope: scope,
      note_text: noteText,
      operation_eq:
        equationStack[equationStack.length - 1].preview.toLowerCase(),
    };
    var isValid = true;
    var currentPreview =
      equationStack[equationStack.length - 1].preview.split(" ");
    var leftBracketCount = currentPreview.filter((op) => op === "(").length;
    var rightBracketCount = currentPreview.filter((op) => op === ")").length;
    if (rightBracketCount !== leftBracketCount) {
      isValid = false;
    }
    if (isValid) {
      if (
        (equationStack.length > 0 &&
          props.operationProp.toUpperCase() !=
            equationStack[equationStack.length - 1].preview) ||
        (props.operationProp && equationStack.length === 0)
      ) {
        dispatch(updateScopedFindingRule(body,machine_type,hmi_type, handleError));
      } else {
        setEdited(false);
        setKeys([]);
        if (equationStack.length > 0) {
          equationStack.splice(0, equationStack.length - 1);
          setEquationStack(equationStack);
        }
      }
    } 
    else {
      setIsValidOperation(false);
    }
  };

  const handleError = (status) => {
    if (status === true) {
      setIsValidOperation(true);
      setEdited(false);
      setKeys([]);
      if (equationStack.length > 0) {
        equationStack.splice(0, equationStack.length - 1);
        setEquationStack(equationStack);
      }
      setEqCreated(true);
      setTimeout(() => {
        dispatch(fetchScopedFindingRule({ finding_rule_id: findingRuleId, machine_type:machine_type,hmi_type:hmi_type,scope: scope }))
      }, 500);
    } else {
      setIsValidOperation(false);
    }
  };

  const handleDiscard = (prop) => {
    if (
      (equationStack.length > 0 &&
        props.operationProp.toUpperCase() !=
          equationStack[equationStack.length - 1].preview) ||
      (props.operationProp && equationStack.length === 0)
    ) {
      setDiscard(!discard);
    } else {
      setEdited(false);
      clearStates();
      setUndoneStack([]);
      if (equationStack.length > 0) {
        equationStack.splice(0, equationStack.length - 1);
        setEquationStack(equationStack);
      }
    }
    if (prop === "ok") {
      setEdited(false);
      clearStates();
      if(props.operationProp.toUpperCase()==='NONE') return;
      createEquationList();
    }
  };

  const handleClearAll = () => {
    if (equationStack.length > 0) {
      setEquationStack([...equationStack, { preview: "", operation: [] }]);
    } else {
      setEquationStack([{ preview: "", operation: [] }]);
    }
    clearStates();
  };

  const reorder = (eqStack, startIndex, endIndex) => {
    let tempOp = Array.from(eqStack.operation);
    let tempPrev = Array.from(eqStack.preview.split(" "));
    let [removed] = tempOp.splice(startIndex, 1);
    tempOp.splice(endIndex, 0, removed);
    [removed] = tempPrev.splice(startIndex, 1);
    tempPrev.splice(endIndex, 0, removed);
    eqStack.operation = tempOp;
    eqStack.preview = tempPrev.join(" ").toUpperCase();
    return eqStack;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const eqStack = reorder(
      { ...equationStack[equationStack.length - 1] },
      result.source.index,
      result.destination.index
    );

    equationStack.push(eqStack);
    setEquationStack(equationStack);
    const lastOp=eqStack.operation[eqStack.operation.length-1]
    setCurrentOperator(lastOp);
  };

  const EditedConfigurationComponent = () => {
    const DraggableComponent = () => {
      return (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='droppable' direction='horizontal'>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
              >
                {equationStack.length > 0 &&
                  equationStack[equationStack.length - 1].operation.map(
                    (equation, index) => (
                      <Draggable
                        key={index}
                        draggableId={`${index}`}
                        index={index}
                        style={{ alignSelf: "center" }}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            {Object.keys(equation)[0] === "rule" ? (
                              <ConfigCard
                                key={index}
                                index={index}
                                equation={equation["rule"]}
                              />
                            ) : (
                              <ConfigOperator
                                key={index}
                                index={index}
                                operator={equation["operator"]}
                              />
                            )}
                          </div>
                        )}
                      </Draggable>
                    )
                  )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      );
    };

    return (
      <Grid
        container
        // direction="column"
        justifyContent='space-between'
        className={classes.equation}
        spacing={3}
      >
        <Grid item style={{ padding: "0px 18px", width: "100%" }}>
          <OperationsComponent
            key='operationsComponent'
            handleDialogOpen={handleDialogOpen}
          />
        </Grid>
        <Grid item container direction='row' alignItems='center'>
          {enableRearrange ? (
            <DraggableComponent />
          ) : (
            equationStack.length > 0 &&
            equationStack[equationStack.length - 1].operation.map(
              (equation, index) => {
                return Object.keys(equation)[0] === "rule" ? (
                  <ConfigCard
                    key={index}
                    index={index}
                    equation={equation["rule"]}
                  />
                ) : (
                  <ConfigOperator
                    key={index}
                    index={index}
                    operator={equation["operator"]}
                  />
                );
              }
            )
          )}

          {((equationStack.length > 0 &&
            currentOperator &&
            Object.keys(currentOperator)[0] === "operator" &&
            Object.values(currentOperator)[0] !== "]") ||
            equationStack.length === 0 ||
            equationStack[equationStack.length - 1].preview === "") && (
            <Button
              onClick={() => handleDialogOpen("paper")}
              className={`btn-dotted ${classes.operatorButton}`}
            >
              + Add Anomaly
            </Button>
          )}
          {rightBracketArray.map((bracket, index) => {
            badgeCount = badgeCount - 1;
            return (
              <Button
                onClick={() => {
                  updateRight(index + 1);
                }}
                className={`btn-dotted ${classes.operatorButton}`}
              >
                {bracket}
              </Button>
            );
          })}
          {
            <SignalsDialog
              open={open}
              handleCloseDialog={handleCloseDialog}
              scroll={scroll}
              handleUpdate={updateEquationStack}
              moduleFrom ="scoped_finding_rule_configuration"
              showTab={true}
            />
          }
        </Grid>
        <Snackbar
          message={"Attempted operation is invalid"}
          open={!isValidOperation}
          onClose={() => setIsValidOperation(!isValidOperation)}
          autoHideDuration={5000}
        />        
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <Snackbar
        message={"Expression created successfully"}
        open={eqCreated}
        onClose={() => setEqCreated(!eqCreated)}
        autoHideDuration={1500}
      />
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className='text-white' />}
          aria-controls='panel1a-content'
          id='panel1a-header'
          className={classes.accordion}
        >
          <Typography className='text-white'>
            Triggering operation (Boolean expression of anomalies)
          </Typography>
          <Tooltip title='question'>
            <HelpOutlineIcon className={classes.icon} />
          </Tooltip>
        </AccordionSummary>
        {(props.operationProp && equationStack.length > 0) ||
        (props.operationProp === "None" && equationStack.length === 0) ? (
          <AccordionDetails>
            <Typography>
              Press EDIT button to start editing the configuration in the
              workspace
              <br />
              You can then add and arrange anomaly rules to the desired
              triggering operation
            </Typography>
            {error && <ErrorHandler message={error} />}
            {edited ? (
              <Grid container direction='row'>
                <Button
                  className={`btn-primary ${classes.editButton}`}
                  onClick={() => handleDone()}
                >
                  Save
                </Button>
                <Button
                  className={`btn-outlined`}
                  variant='outlined'
                  onClick={() => handleDiscard()}
                >
                  DISCARD
                </Button>
                <DiscardDialog />
                <Button
                  className={`btn-outlined`}
                  variant='outlined'
                  disabled={equationStack.length === 0 || equationStack[equationStack.length - 1].preview === ""}
                  onClick={() => handleClearAll()}
                  style={{ position: "absolute", right: 0 }}
                >
                  CLEAR ALL
                </Button>
              </Grid>
            ) : (
              <Button
                className={`btn-primary ${classes.editButton}`}
                onClick={() => setEdited(true)}
              >
                EDIT
              </Button>
            )}
            <Typography>
              {`Operation Preview - ${
                equationStack.length > 0
                  ? equationStack[equationStack.length - 1].preview
                  : ""
              }`}
            </Typography>
            <Paper className={classes.configPaper} elevation={0}>
              {edited ? (
                <EditedConfigurationComponent />
              ) : (
                <ConfigurationComponent />
              )}
            </Paper>
          </AccordionDetails>
        ) : (
          <SkeletonPaper row={1} />
        )}
      </Accordion>
    </div>
  );
})

export default React.memo (AnomalyConfiguration)

